export const pageAnimationConfig = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 1.4 },
};

export const toSentenceCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/\.\s+([a-z])[^.]|^(\s*[a-z])[^.]/g, (s) =>
      s.replace(/([a-z])/, (s) => s.toUpperCase())
    );
};

export function camelCaseToSeparateWords(str) {
  if (!str) return "";
  return str.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
}

export function separatePhoneNumberString(phoneNumber) {
  const firstDigit = phoneNumber.split("")[0] !== "+" ? "+" : "";
  if (!phoneNumber || phoneNumber.length < 11) {
    return {
      code: null,
      number: null,
    };
  }

  return {
    code: firstDigit + phoneNumber.slice(0, -10),
    number: phoneNumber.slice(phoneNumber?.length - 10),
  };
}

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function formatNumber(price) {
  return new Intl.NumberFormat().format(price);
}

export function formatSelectOptionForAntd(arrayOfStrings) {
  return (
    arrayOfStrings?.map((item) => ({
      label: item,
      value: item,
    })) || []
  );
}

export function limitString(text) {
  if (!text) return "";
  if (text.length > 17) return `${text.substring(0, 17)}...`;
  return text;
}
